module.exports = __webpack_public_path__ + "assets/password-strength-zwak.svg";